// import axios from 'axios';
import loadingMutation from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';
import programsAPI from '@/api/artist/programs.js';

const state = {
  gcpSubscriptionProgram: null,
  loading: false,
};

const getters = {
  isGcpSubscriptionActive({ gcpSubscriptionProgram }) {
    return _.get(gcpSubscriptionProgram, 'status') === 'active';
  },
  isGcpSubscriptionLoaded({ gcpSubscriptionProgram }) {
    return gcpSubscriptionProgram !== null;
  },
};

const actions = {
  GET_GCP_SUBSCRIPTION_PROGRAM({ state, commit }) {
    if (!state.gcpSubscriptionProgram) {
      commit('setLoading', true);
      return programsAPI.getProgram('gcp_subscription')
        .then(({ data: { data: program } }) => {
          commit('setGcpSubscriptionProgram', program);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    }
  },
};

const mutations = {
  setGcpSubscriptionProgram(state, program) {
    console.log('=============== COMMIT gcpSubscription/setGcpSubscriptionProgram', program);
    state.gcpSubscriptionProgram = program;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: {
    ...mutations,
    ...loadingMutation,
  },
};
